"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { ScrollSmoother, ScrollTrigger } from "gsap/all";

const RouteChangeRefresh = () => {
  const pathname = usePathname();

  useEffect(() => {
    const smoother = ScrollSmoother.get();

    if (smoother) {
      smoother.scrollTo(0, false);
    } else {
      window.scrollTo(0, 0);
    }

    const raf = requestAnimationFrame(() => {
      ScrollTrigger.clearScrollMemory();
      ScrollTrigger.sort();
      ScrollTrigger.refresh(true);
    });

    return () => cancelAnimationFrame(raf);
  }, [pathname]);

  return null;
};

export default RouteChangeRefresh;
